import { render, staticRenderFns } from "./CrossIconBlackNew.vue?vue&type=template&id=c4ff3636"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4ff3636')) {
      api.createRecord('c4ff3636', component.options)
    } else {
      api.reload('c4ff3636', component.options)
    }
    module.hot.accept("./CrossIconBlackNew.vue?vue&type=template&id=c4ff3636", function () {
      api.rerender('c4ff3636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CrossIconBlackNew.vue"
export default component.exports